export const PASSWORD_MIN_LENGTH = 10;

export const PASSWORD_REQUIREMENT =
  "Lykilorð verður að vera minnst 10 stafir og innihalda hástaf, lágstaf og tölu.";

export const PASSWORD_MISMATCH = "Lykilorðin stemma ekki.";

export function validatePassword(password: string): string | null {
  if (
    password.length < PASSWORD_MIN_LENGTH ||
    !/[A-ZÁÉÍÓÚÝÞÆÖÐ]/.test(password) ||
    !/[a-záéíóúýþæöð]/.test(password) ||
    !/[0-9]/.test(password)
  ) {
    return PASSWORD_REQUIREMENT;
  }
  return null;
}

export interface PasswordCheck {
  label: string;
  met: boolean;
}

export function passwordChecks(password: string): PasswordCheck[] {
  return [
    {
      label: `Minnst ${PASSWORD_MIN_LENGTH} stafir`,
      met: password.length >= PASSWORD_MIN_LENGTH,
    },
    { label: "Einn hástafur (A–Ö)", met: /[A-ZÁÉÍÓÚÝÞÆÖÐ]/.test(password) },
    { label: "Einn lágstafur (a–ö)", met: /[a-záéíóúýþæöð]/.test(password) },
    { label: "Ein tala (0–9)", met: /[0-9]/.test(password) },
  ];
}
